<template>
  <div class="pengaturan-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row>
      <v-col cols="12">
        <v-card class="pengaturan-card animated animate__bounceIn elevation-0">
          <div class="pengaturan-toolbar">
            <div class="pengaturan-toolbar__left">
              <div class="pengaturan-toolbar__icon">
                <v-icon>mdi-whatsapp</v-icon>
              </div>
              <div>
                <div class="pengaturan-toolbar__title">Pengaturan WhatsApp</div>
                <div class="pengaturan-toolbar__sub">
                  {{ records.length || 0 }} service terdaftar
                </div>
              </div>
            </div>

            <div class="pengaturan-toolbar__actions">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Cari service / nomor..."
                single-line
                hide-details
                dense
                outlined
                color="#1f7a57"
                class="pengaturan-search"
                clearable
              ></v-text-field>

              <v-tooltip bottom color="#0d4a36">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="pengaturan-icon-btn"
                    v-on="on"
                    v-show="page.actions.refresh"
                    @click="fetchRecords"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Muat ulang</span>
              </v-tooltip>

              <v-btn
                class="pengaturan-btn-primary"
                v-show="page.actions.add && canAddService"
                @click="openForm"
              >
                <v-icon left small>mdi-plus</v-icon>
                Tambah Service
              </v-btn>
              <div
                v-if="page.actions.add && !canAddService"
                class="pengaturan-limit-hint"
              >
                {{ addBlockedHint }}
              </div>
            </div>
          </div>

          <!-- Desktop table -->
          <v-data-table
            v-show="device.desktop"
            :headers="headers"
            :items="records"
            :items-per-page="table.options.itemsPerPage"
            :page.sync="table.options.page"
            class="pengaturan-table"
            :loading="loading.table"
            loading-text="Memuat pengaturan..."
            :search="search"
            hide-default-footer
            @page-count="table.options.pageCount = $event"
          >
            <v-progress-linear
              slot="progress"
              color="#1f7a57"
              height="2"
              indeterminate
            ></v-progress-linear>

            <template v-slot:item.name="{ item }">
              <div class="pengaturan-name-cell">
                <div class="pengaturan-name-cell__mark">
                  <v-icon small>mdi-whatsapp</v-icon>
                </div>
                <div>
                  <div class="pengaturan-name-cell__title">{{ item.name }}</div>
                  <div class="pengaturan-name-cell__hint">
                    Antrian {{ item.queue || 0 }} detik
                  </div>
                </div>
              </div>
            </template>

            <template v-slot:item.phone_number="{ value }">
              <span class="pengaturan-phone">{{ value || '—' }}</span>
            </template>

            <template v-slot:item.status="{ value }">
              <span
                class="pengaturan-status"
                :class="statusClass(value)"
              >
                <span class="pengaturan-status__dot"></span>
                {{ statusText(value) }}
              </span>
            </template>

            <template v-slot:item.id="{ item }">
              <div class="pengaturan-row-actions">
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="pengaturan-action-qr"
                      v-on="on"
                      v-show="page.actions.edit"
                      @click="openScanBarcode(item)"
                    >
                      <v-icon small>mdi-qrcode</v-icon>
                    </v-btn>
                  </template>
                  <span>Pindai QR</span>
                </v-tooltip>
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="pengaturan-action-edit"
                      v-on="on"
                      v-show="page.actions.edit"
                      @click="editRecord(item.id || item.uuid)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Ubah</span>
                </v-tooltip>
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="pengaturan-action-delete"
                      v-on="on"
                      v-show="page.actions.delete"
                      @click="postDeleteRecord(item.id || item.uuid)"
                    >
                      <v-icon small>mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Hapus</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:no-data>
              <div class="pengaturan-empty">
                <v-icon large color="#8fd6b5">mdi-whatsapp</v-icon>
                <div class="pengaturan-empty__title">Belum ada service</div>
                <div class="pengaturan-empty__sub">
                  Tambahkan nomor WhatsApp untuk mulai mengirim pesan
                </div>
                <v-btn
                  class="pengaturan-btn-primary mt-4"
                  small
                  v-show="page.actions.add && canAddService"
                  @click="openForm"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Tambah Service
                </v-btn>
              </div>
            </template>
          </v-data-table>

          <!-- Mobile cards -->
          <div class="pengaturan-mobile" v-show="device.mobile">
            <div
              v-for="item in filterItems"
              :key="item.id"
              class="pengaturan-mobile-card"
            >
              <div class="pengaturan-mobile-card__top">
                <div class="pengaturan-name-cell">
                  <div class="pengaturan-name-cell__mark">
                    <v-icon small>mdi-whatsapp</v-icon>
                  </div>
                  <div>
                    <div class="pengaturan-name-cell__title">{{ item.name }}</div>
                    <div class="pengaturan-phone mt-1">{{ item.phone_number }}</div>
                  </div>
                </div>
                <v-menu bottom left origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" class="pengaturan-menu-btn">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="pengaturan-menu">
                    <v-list-item
                      @click="openScanBarcode(item)"
                      v-show="page.actions.edit"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#1f7a57">mdi-qrcode</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Pindai QR</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="editRecord(item.id || item.uuid)"
                      v-show="page.actions.edit"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#1f7a57">mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ubah Data</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="postDeleteRecord(item.id || item.uuid)"
                      v-show="page.actions.delete"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#c62828">mdi-delete-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Hapus Data</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="pengaturan-mobile-card__meta">
                <span
                  class="pengaturan-status"
                  :class="statusClass(item.status)"
                >
                  <span class="pengaturan-status__dot"></span>
                  {{ statusText(item.status) }}
                </span>
                <span class="pengaturan-mobile-card__queue">
                  Antrian {{ item.queue || 0 }} dtk
                </span>
              </div>
            </div>

            <div v-if="!filterItems.length" class="pengaturan-empty pa-8">
              <v-icon large color="#8fd6b5">mdi-whatsapp</v-icon>
              <div class="pengaturan-empty__title">Belum ada service</div>
              <div class="pengaturan-empty__sub">
                Tambahkan nomor WhatsApp untuk mulai mengirim pesan
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Form dialog -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="form.add"
      :max-width="device.desktop ? '560px' : '100%'"
      persistent
      :fullscreen="device.mobile"
      content-class="pengaturan-dialog"
    >
      <v-card class="pengaturan-dialog-card">
        <div class="pengaturan-dialog-header">
          <div class="pengaturan-dialog-header__copy">
            <v-icon class="mr-2">mdi-cog-outline</v-icon>
            {{ form.edit ? 'Ubah Pengaturan WhatsApp' : 'Tambah Pengaturan WhatsApp' }}
          </div>
          <v-btn icon dark small @click="closeForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pengaturan-dialog-body">
          <div class="pengaturan-field-label">Nama Service</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Contoh: CS Utama, Marketing"
            v-model="record.name"
            dense
            class="pengaturan-field mb-4"
            prepend-inner-icon="mdi-label-outline"
          ></v-text-field>

          <div class="pengaturan-field-label">Nomor Telepon (WA)</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="62812xxxxxxxx"
            v-model="record.phone_number"
            dense
            class="pengaturan-field mb-4"
            prepend-inner-icon="mdi-phone"
          ></v-text-field>

          <div class="pengaturan-field-label">Jarak Pengiriman Per Pesan</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            type="number"
            placeholder="Disarankan 8–15 detik"
            v-model="record.queue"
            dense
            class="pengaturan-field mb-1"
            prepend-inner-icon="mdi-timer-outline"
            suffix="detik"
          ></v-text-field>
          <div class="pengaturan-hint mb-4">
            Jarak antar pesan (minimal 5 detik). Nilai lebih tinggi mengurangi risiko dianggap spam.
          </div>

          <div class="pengaturan-field-label">API Key</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Otomatis dibuat sistem"
            v-model="record.api_key"
            dense
            disabled
            class="pengaturan-field mb-4"
            prepend-inner-icon="mdi-key-variant"
          ></v-text-field>

          <div class="pengaturan-field-label">Callback URL</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Opsional — URL notifikasi balik"
            v-model="record.callback_url"
            dense
            class="pengaturan-field"
            prepend-inner-icon="mdi-link-variant"
          ></v-text-field>
        </v-card-text>

        <v-divider class="pengaturan-divider"></v-divider>
        <v-card-actions class="pengaturan-dialog-actions">
          <v-btn text class="pengaturan-btn-ghost" @click="closeForm">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="pengaturan-btn-primary"
            v-show="!form.edit"
            @click="postAddNewRecord"
          >
            <v-icon left small>mdi-plus</v-icon>
            Tambah
          </v-btn>
          <v-btn
            class="pengaturan-btn-primary"
            v-show="form.edit"
            @click="postUpdateRecord"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- QR Scan dialog -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="barcode.form.show"
      :max-width="device.desktop ? '640px' : '100%'"
      persistent
      content-class="pengaturan-dialog"
    >
      <v-card class="pengaturan-dialog-card">
        <div class="pengaturan-dialog-header">
          <div class="pengaturan-dialog-header__copy">
            <v-icon class="mr-2">mdi-qrcode-scan</v-icon>
            Hubungkan WhatsApp
          </div>
          <v-btn icon dark small @click="closeScanBarcode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pengaturan-qr-body">
          <div class="pengaturan-qr-layout">
            <div class="pengaturan-qr-panel">
              <div class="pengaturan-qr-frame">
                <img
                  v-if="whatsapp.qr.show && whatsapp.qr.src"
                  :src="whatsapp.qr.src"
                  alt="QR Code"
                  class="pengaturan-qr-image"
                />
                <img
                  v-else-if="whatsapp.authenticated.imgUrl"
                  :src="whatsapp.authenticated.imgUrl"
                  alt="Profil WhatsApp"
                  class="pengaturan-qr-avatar"
                />
                <div v-else class="pengaturan-qr-placeholder">
                  <v-icon large color="#8fd6b5">mdi-qrcode</v-icon>
                  <span>Menunggu QR...</span>
                </div>
              </div>
              <div class="pengaturan-qr-message">
                {{
                  whatsapp.authenticated.status
                    ? whatsapp.authenticated.status
                    : (whatsapp.qr.message || 'Scan QR dengan WhatsApp di ponsel Anda')
                }}
              </div>
            </div>

            <div class="pengaturan-qr-info">
              <div class="pengaturan-qr-info__title">Detail Sesi</div>
              <div class="pengaturan-qr-row">
                <span>ID</span>
                <strong>{{ whatsapp.authenticated.id || record.phone_number || '—' }}</strong>
              </div>
              <div class="pengaturan-qr-row">
                <span>Pengguna</span>
                <strong>{{ whatsapp.authenticated.name || record.name || '—' }}</strong>
              </div>
              <div class="pengaturan-qr-row">
                <span>Nomor</span>
                <strong>{{ record.phone_number || '—' }}</strong>
              </div>
              <div class="pengaturan-qr-row">
                <span>Status</span>
                <span
                  class="pengaturan-status"
                  :class="whatsapp.authenticated.status ? 'is-online' : 'is-idle'"
                >
                  <span class="pengaturan-status__dot"></span>
                  {{ whatsapp.authenticated.status || 'Menunggu' }}
                </span>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider class="pengaturan-divider"></v-divider>
        <v-card-actions class="pengaturan-dialog-actions">
          <v-btn
            outlined
            class="pengaturan-btn-danger"
            @click="logout(record.id)"
          >
            <v-icon left small>mdi-logout</v-icon>
            Logout
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="pengaturan-btn-primary" @click="closeScanBarcode">
            Selesai
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import "animate.css";

export default {
  name: "MasterPengaturan",
  data: () => ({
    headers: [
      {
        text: "Service",
        align: "start",
        sortable: true,
        value: "name",
      },
      {
        text: "Nomor",
        align: "start",
        sortable: true,
        value: "phone_number",
      },
      {
        text: "Status",
        align: "start",
        sortable: false,
        value: "status",
        width: 160,
      },
      {
        text: "Aksi",
        value: "id",
        width: 140,
        sortable: false,
        align: "center",
      },
    ],
    search: null,
    barcode: {
      form: {
        show: false,
      },
      qr: {
        id: null,
        src: null,
        show: true,
      },
    },
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "event",
      "snackbar",
      "form",
      "table",
      "whatsapp",
      "user",
    ]),
    filterItems() {
      if (!this.search) return this.records || [];
      const q = this.search.toLowerCase();
      return (this.records || []).filter((item) => {
        const name = (item.name || "").toLowerCase();
        const phone = (item.phone_number || "").toLowerCase();
        return name.indexOf(q) > -1 || phone.indexOf(q) > -1;
      });
    },
    paketMaxWa() {
      const p = this.user && this.user.paket;
      if (!p || p.unlimited) return null;
      return p.max_wa;
    },
    hasPaket() {
      const p = this.user && this.user.paket;
      if (!p) return false;
      if (p.unlimited) return true;
      return !!p.has_paket;
    },
    canAddService() {
      if (!this.hasPaket) return false;
      if (this.paketMaxWa == null) return true;
      return (this.records || []).length < this.paketMaxWa;
    },
    addBlockedHint() {
      if (!this.hasPaket) {
        return "Akun belum punya paket — hubungi admin";
      }
      return "Limit paket: " + this.paketMaxWa + " nomor WA";
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/superadmin/master-data/pengaturan",
      pagination: false,
      title: "MASTER PENGATURAN",
      subtitle: "Berikut Daftar Seluruh Pengaturan Yang Tersedia",
      showtable: true,
      breadcrumbs: [
        {
          text: "Data Master",
          disabled: true,
          href: "",
        },
        {
          text: "Pengaturan",
          disabled: false,
          href: "",
        },
      ],
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
        bulkdelete: true,
        print: false,
        export: false,
        help: false,
      },
    });
    this.fetchRecords();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postAddNew",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "assignFileBrowse",
      "setLoading",
      "setRecord",
      "setForm",
      "setWaQr",
      "setWaAuth",
    ]),
    statusText(value) {
      if (!value) return "Tidak aktif";
      if (typeof value === "object") return value.text || "Tidak aktif";
      const text = String(value).toLowerCase();
      if (text.includes("connect") || text.includes("aktif") || text === "1" || text === "true") {
        return "Terhubung";
      }
      return String(value);
    },
    statusClass(value) {
      if (!value) return "is-idle";
      if (typeof value === "object") {
        const color = (value.color || "").toLowerCase();
        const text = (value.text || "").toLowerCase();
        if (color.includes("green") || text.includes("connect") || text.includes("aktif")) {
          return "is-online";
        }
        return "is-idle";
      }
      const text = String(value).toLowerCase();
      if (text.includes("connect") || text.includes("aktif") || text === "1" || text === "true") {
        return "is-online";
      }
      return "is-idle";
    },
    openForm: function () {
      if (!this.canAddService) {
        this.snackbar.color = "orange";
        this.snackbar.text = !this.hasPaket
          ? "Akun belum memiliki paket. Hubungi admin untuk assign paket."
          : "Paket Anda membatasi maksimal " +
            this.paketMaxWa +
            " nomor WhatsApp";
        this.snackbar.state = true;
        return;
      }
      this.setForm({
        add: true,
        edit: false,
      });
      this.setRecord({});
    },
    closeForm: function () {
      this.setForm({
        add: false,
        edit: false,
      });
    },
    postAddNewRecord: function () {
      this.postAddNew(this.record).then(() => {
        this.closeForm();
      });
    },
    editRecord: function (val) {
      this.postEdit(val);
      this.setForm({
        add: true,
        edit: true,
      });
    },
    postUpdateRecord: function () {
      this.postUpdate(this.record).then(() => {
        this.closeForm();
      });
    },
    postDeleteRecord: function (val) {
      this.postConfirmDelete(val);
    },
    postDownload(val) {
      window.open(val, "__blank");
    },
    openScanBarcode: async function (val) {
      // val bisa: object row, uuid, atau nomor
      let phone =
        (val && typeof val === "object"
          ? val.phone_number || val.phoneNumber
          : null) || null;
      let rowId =
        (val && typeof val === "object" ? val.id || val.uuid : null) ||
        (typeof val === "string" || typeof val === "number" ? val : null);

      // Jika val string angka panjang → itu nomor HP
      if (!phone && val != null && /^\d{8,16}$/.test(String(val))) {
        phone = String(val);
      }

      // Load record dulu kalau belum punya nomor
      if (!phone && rowId) {
        try {
          await this.postEdit(rowId);
          phone = this.record.phone_number || this.record.phoneNumber || null;
        } catch (e) {}
      } else if (val && typeof val === "object") {
        this.postEdit(val.id || val.uuid || rowId);
      }

      if (!phone) {
        phone = this.record.phone_number || this.record.phoneNumber || null;
      }

      phone = phone ? String(phone).replace(/\D/g, "") : "";

      if (!phone) {
        this.snackbar.color = "#b45309";
        this.snackbar.text = "Nomor WhatsApp tidak ditemukan pada data ini";
        this.snackbar.state = true;
        return;
      }

      this.barcode.form.show = true;

      this.setWaQr({
        id: phone,
        src: null,
        show: true,
        message: "Menyalakan Chromium, menunggu QR...",
      });
      this.setWaAuth({ clear: true, show: false });

      if (this._qrWaitTimer) {
        clearTimeout(this._qrWaitTimer);
        this._qrWaitTimer = null;
      }

      this.http
        .post("api/superadmin/master-data/pengaturan-register", {
          phone_number: phone,
          force: false,
        })
        .then(({ data }) => {
          const payload = (data && data.data) || data || {};
          const message =
            payload.message ||
            (data && data.message) ||
            "Menunggu QR dari WhatsApp...";

          if (payload.connected) {
            this.setWaAuth({
              id: payload.id || phone,
              name: payload.name || (val && val.name) || "WhatsApp",
              status: "Terhubung",
              image: "/images/ok.png",
              show: true,
            });
            this.setWaQr({
              id: phone,
              src: null,
              show: false,
              message: "Terhubung",
            });
            return;
          }

          if (payload.success === false) {
            this.setWaQr({
              id: phone,
              src: null,
              show: true,
              message: payload.message || "Gagal menyiapkan sesi",
            });
            return;
          }

          this.setWaQr({
            id: phone,
            src: this.whatsapp.qr.src || null,
            show: true,
            message: message,
          });

          this._qrWaitTimer = setTimeout(() => {
            if (
              this.barcode.form.show &&
              !this.whatsapp.authenticated.status &&
              !this.whatsapp.qr.src
            ) {
              this.setWaQr({
                id: phone,
                src: null,
                show: true,
                message: "QR belum muncul, mencoba ulang...",
              });
              this.http
                .post("api/superadmin/master-data/pengaturan-register", {
                  phone_number: phone,
                  force: true,
                })
                .then(() => {
                  this.setWaQr({
                    id: phone,
                    src: null,
                    show: true,
                    message: "Menyiapkan QR baru, mohon tunggu...",
                  });
                })
                .catch(() => {
                  this.setWaQr({
                    id: phone,
                    src: null,
                    show: true,
                    message:
                      "Gagal menyiapkan QR. Cek Chrome di server lalu coba lagi.",
                  });
                });
            }
          }, 45000);
        })
        .catch(() => {
          this.setWaAuth({ clear: true, show: false });
          this.setWaQr({
            id: phone,
            src: null,
            show: true,
            message: "Gagal memulai sesi. Coba lagi / cek Chrome di server.",
          });
        });
    },
    closeScanBarcode: function () {
      if (this._qrWaitTimer) {
        clearTimeout(this._qrWaitTimer);
        this._qrWaitTimer = null;
      }
      this.barcode.form.show = false;
    },
    logout: async function () {
      const phone =
        this.record.phone_number ||
        this.whatsapp.qr.id ||
        this.whatsapp.authenticated.id;

      if (!phone) {
        this.snackbar.color = "#b45309";
        this.snackbar.text = "Nomor WhatsApp tidak ditemukan";
        this.snackbar.state = true;
        return;
      }

      try {
        await this.http.post(
          "api/superadmin/master-data/pengaturan-logout",
          { phone_number: phone }
        );
        this.setWaQr({
          id: phone,
          src: null,
          show: true,
          message: "Sesi & folder session dihapus. Scan QR untuk menghubungkan ulang.",
        });
        this.setWaAuth({
          clear: true,
          show: false,
        });
        this.snackbar.color = "#1f7a57";
        this.snackbar.text = "Logout berhasil, folder session dihapus";
        this.snackbar.state = true;
      } catch (e) {
        this.snackbar.color = "#b45309";
        this.snackbar.text = "Gagal logout sesi WhatsApp";
        this.snackbar.state = true;
      }
    },
  },
};
</script>

<style scoped>
.pengaturan-page {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-paper: #f8fbf9;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
}

.pengaturan-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
  background: #fff !important;
}

.pengaturan-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.15rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.pengaturan-toolbar__left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.pengaturan-toolbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.pengaturan-toolbar__icon .v-icon {
  color: #0b3d2e !important;
}

.pengaturan-toolbar__title {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
  line-height: 1.2;
}

.pengaturan-toolbar__sub {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: rgba(244, 251, 247, 0.65);
}

.pengaturan-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.pengaturan-search {
  max-width: 280px;
  min-width: 180px;
}

.pengaturan-search >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 10px !important;
  min-height: 38px !important;
}

.pengaturan-search >>> fieldset {
  border-color: rgba(143, 214, 181, 0.35) !important;
}

.pengaturan-search >>> input,
.pengaturan-search >>> .v-icon {
  color: #f4fbf7 !important;
}

.pengaturan-search >>> input::placeholder {
  color: rgba(244, 251, 247, 0.55) !important;
}

.pengaturan-icon-btn {
  color: #f4fbf7 !important;
}

.pengaturan-icon-btn:hover {
  background: rgba(143, 214, 181, 0.18) !important;
}

.pengaturan-btn-primary {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5) !important;
  color: #0b3d2e !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.pengaturan-limit-hint {
  font-size: 0.75rem;
  font-weight: 600;
  color: #8a6d3b;
  background: #fff8e6;
  border: 1px solid #f0e0b2;
  border-radius: 8px;
  padding: 0.35rem 0.6rem;
  white-space: nowrap;
}

.pengaturan-btn-primary:hover {
  background: linear-gradient(145deg, #c8f0da, #9fdebf) !important;
}

.pengaturan-table {
  background: transparent !important;
}

.pengaturan-table >>> thead th {
  background: var(--gw-fog) !important;
  color: var(--gw-forest) !important;
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-bottom: 1px solid var(--gw-line) !important;
}

.pengaturan-table >>> tbody td {
  border-bottom: 1px solid var(--gw-line) !important;
  color: var(--gw-ink);
  height: 68px !important;
}

.pengaturan-table >>> tbody tr:hover {
  background: rgba(143, 214, 181, 0.08) !important;
}

.pengaturan-name-cell {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.pengaturan-name-cell__mark {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.pengaturan-name-cell__mark .v-icon {
  color: #0b3d2e !important;
}

.pengaturan-name-cell__title {
  font-weight: 600;
  color: var(--gw-ink);
  line-height: 1.2;
}

.pengaturan-name-cell__hint {
  margin-top: 0.15rem;
  font-size: 0.72rem;
  color: var(--gw-muted);
}

.pengaturan-phone {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 600;
  color: var(--gw-forest);
  letter-spacing: 0.02em;
}

.pengaturan-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid var(--gw-line);
  background: #fff;
  color: var(--gw-muted);
}

.pengaturan-status.is-online {
  border-color: rgba(31, 122, 87, 0.25);
  background: rgba(143, 214, 181, 0.2);
  color: var(--gw-forest);
}

.pengaturan-status.is-idle {
  border-color: var(--gw-line);
  background: var(--gw-fog);
  color: var(--gw-muted);
}

.pengaturan-status__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #91a59b;
}

.pengaturan-status.is-online .pengaturan-status__dot {
  background: var(--gw-leaf);
  box-shadow: 0 0 0 3px rgba(31, 122, 87, 0.15);
}

.pengaturan-row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.1rem;
}

.pengaturan-action-qr,
.pengaturan-action-edit {
  color: var(--gw-leaf) !important;
}

.pengaturan-action-delete {
  color: #c62828 !important;
}

.pengaturan-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 1rem;
  text-align: center;
}

.pengaturan-empty__title {
  margin-top: 0.75rem;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: var(--gw-ink);
}

.pengaturan-empty__sub {
  margin-top: 0.25rem;
  font-size: 0.88rem;
  color: var(--gw-muted);
  max-width: 320px;
}

.pengaturan-mobile {
  padding: 0.85rem;
  display: grid;
  gap: 0.75rem;
}

.pengaturan-mobile-card {
  border: 1px solid var(--gw-line);
  border-radius: 12px;
  padding: 0.9rem;
  background: #fff;
}

.pengaturan-mobile-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.pengaturan-mobile-card__meta {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--gw-line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.pengaturan-mobile-card__queue {
  font-size: 0.78rem;
  color: var(--gw-muted);
}

.pengaturan-menu-btn {
  color: var(--gw-forest) !important;
}

.pengaturan-menu {
  border-radius: 10px !important;
}

.pengaturan-dialog-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.pengaturan-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.95rem 1.1rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.pengaturan-dialog-header__copy {
  display: flex;
  align-items: center;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 600;
}

.pengaturan-dialog-header__copy .v-icon {
  color: var(--gw-mint) !important;
}

.pengaturan-dialog-body {
  padding: 1.25rem 1.25rem 0.5rem !important;
}

.pengaturan-field-label {
  margin-bottom: 0.4rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--gw-forest);
}

.pengaturan-hint {
  font-size: 0.8rem;
  line-height: 1.45;
  color: var(--gw-muted);
}

.pengaturan-field >>> .v-input__slot {
  border-radius: 10px !important;
}

.pengaturan-field >>> .v-icon {
  color: var(--gw-leaf) !important;
}

.pengaturan-divider {
  border-color: var(--gw-line) !important;
}

.pengaturan-dialog-actions {
  padding: 0.9rem 1.1rem !important;
  background: var(--gw-paper);
}

.pengaturan-btn-ghost {
  color: var(--gw-muted) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

.pengaturan-btn-danger {
  color: #c62828 !important;
  border-color: rgba(198, 40, 40, 0.35) !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

.pengaturan-qr-body {
  padding: 1.25rem !important;
}

.pengaturan-qr-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.25rem;
  align-items: start;
}

.pengaturan-qr-panel {
  text-align: center;
}

.pengaturan-qr-frame {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 220px;
  border-radius: 14px;
  border: 1px solid var(--gw-line);
  background:
    radial-gradient(120% 80% at 0% 0%, rgba(26, 107, 77, 0.12) 0%, transparent 55%),
    var(--gw-fog);
  padding: 1rem;
}

.pengaturan-qr-image {
  width: 200px;
  height: 200px;
  border-radius: 10px;
  background: #fff;
}

.pengaturan-qr-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--gw-mint);
}

.pengaturan-qr-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  color: var(--gw-muted);
  font-size: 0.85rem;
}

.pengaturan-qr-message {
  margin-top: 0.85rem;
  font-size: 0.85rem;
  color: var(--gw-muted);
}

.pengaturan-qr-info {
  border: 1px solid var(--gw-line);
  border-radius: 14px;
  padding: 1rem;
  background: var(--gw-paper);
}

.pengaturan-qr-info__title {
  margin-bottom: 0.85rem;
  font-family: "Outfit", sans-serif;
  font-weight: 700;
  color: var(--gw-ink);
}

.pengaturan-qr-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid var(--gw-line);
  font-size: 0.88rem;
}

.pengaturan-qr-row:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.pengaturan-qr-row span:first-child {
  color: var(--gw-muted);
}

.pengaturan-qr-row strong {
  color: var(--gw-ink);
  text-align: right;
}

@media (max-width: 600px) {
  .pengaturan-toolbar__actions {
    width: 100%;
  }

  .pengaturan-search {
    max-width: none;
    flex: 1;
    min-width: 0;
  }

  .pengaturan-toolbar__actions .pengaturan-btn-primary {
    width: 100%;
  }

  .pengaturan-qr-layout {
    grid-template-columns: 1fr;
  }
}
</style>
